import { h, Host, } from "@stencil/core";
import { theme } from "@eventstore-ui/theme";
/** @internal */
export class EsToast {
  constructor() {
    this.enter = () => {
      this.transitionState = 'mounted';
    };
    this.level = undefined;
    this.count = undefined;
    this.icon = undefined;
    this.transitionState = 'mounting';
  }
  async close() {
    return new Promise((resolve) => {
      const hasLeft = () => {
        this.host.removeEventListener('transitionend', hasLeft);
        resolve();
      };
      this.host.addEventListener('transitionend', hasLeft);
      this.transitionState = 'unmounting';
    });
  }
  componentDidLoad() {
    requestAnimationFrame(this.enter);
  }
  render() {
    return (h(Host, { class: `${this.level} ${this.transitionState}`, "high-contrast": theme.isHighContrast(), dark: theme.isDark() }, h("div", { class: 'inner' }, h("div", { class: 'icon_holder' }, this.count > 1 ? (h("es-counter", { count: this.count, variant: 'minimal' })) : (h("es-icon", { icon: this.icon, size: 22 }))), h("div", { class: 'content' }, h("slot", null)))));
  }
  static get is() { return "es-toast"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-toast.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-toast.css"]
    };
  }
  static get properties() {
    return {
      "level": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "ToastLevel",
          "resolved": "\"error\" | \"info\" | \"success\" | \"warning\"",
          "references": {
            "ToastLevel": {
              "location": "import",
              "path": "../types",
              "id": "src/components/toast/types.ts::ToastLevel"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "level",
        "reflect": false
      },
      "count": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "Toast['count']",
          "resolved": "number",
          "references": {
            "Toast": {
              "location": "import",
              "path": "../types",
              "id": "src/components/toast/types.ts::Toast"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "count",
        "reflect": false
      },
      "icon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "Toast['icon']",
          "resolved": "[namespace: string | symbol, name: string] | string",
          "references": {
            "Toast": {
              "location": "import",
              "path": "../types",
              "id": "src/components/toast/types.ts::Toast"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "transitionState": {}
    };
  }
  static get methods() {
    return {
      "close": {
        "complexType": {
          "signature": "() => Promise<void>",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global",
              "id": "global::Promise"
            }
          },
          "return": "Promise<void>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      }
    };
  }
  static get elementRef() { return "host"; }
}
//# sourceMappingURL=es-toast.js.map
